/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useLotData } from "../../../../../../api/inventory/use-lot-data";
import Modal from "../../../../../../components/ui/Modal/Modal";
import Table from "../../../../../../components/ui/Table/Table";
import InventodyLinkageModal from "./InventoryLinkageModal";

const columnHelper = createColumnHelper();

const columns = (
  page,
  pageSize,
  total,
  productData,
  triggerCloseLinkageModal,
  onCloseLinkageModal,
  setTriggerCloseLinkageModal,
  setTriggerCloseDataModal
) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row.productLotInfo.type, {
      header: "구분",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (val === "SMART" ? "스마트팩토리 연동" : "수동 등록") : "-"}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row.used, {
      header: "재고 연동여부",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val === false ? (
              <span className="text-[#e80000]">미연동</span>
            ) : (
              "연동"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row.productLotInfo.lotNo, {
      header: "LOT",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),
    columnHelper.accessor((row) => row.productLotInfo.manufacDate, {
      header: "제조일자",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? dayjs(val).format("YYYY-MM-DD") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.productLotInfo.expireDate, {
      header: "유효일자",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? dayjs(val).format("YYYY-MM-DD") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.qnt, {
      header: "입고수량",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val}</div>;
      },
    }),

    columnHelper.accessor((row) => row.updatedAt, {
      header: "최종 업데이트일",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? dayjs(val).format("YYYY-MM-DD") : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.qnt, {
      header: "[연동] 현재 재고수량",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val}</div>;
      },
    }),

    columnHelper.display({
      header: "재고 연동관리",
      id: "actions",
      cell: (info) =>
        ButtonActions(
          info,
          productData,
          triggerCloseLinkageModal,
          onCloseLinkageModal,
          setTriggerCloseLinkageModal,
          setTriggerCloseDataModal
        ),
    }),
  ];
};

function ButtonActions(
  info,
  productData,
  triggerCloseLinkageModal,
  onCloseLinkageModal,
  setTriggerCloseLinkageModal,
  setTriggerCloseDataModal
) {
  const value = info?.row?.original;
  const linkage = value?.used;
  return linkage === false ? (
    <Modal
      maxWidth="max-w-fit"
      description={
        <InventodyLinkageModal
          id={value?.id}
          qrData={value}
          productData={productData}
          onCloseLinkageModal={onCloseLinkageModal}
          setTriggerCloseLinkageModal={setTriggerCloseLinkageModal}
          setTriggerCloseDataModal={setTriggerCloseDataModal}
        />
      }
      hasClose={false}
      hasSubmit={false}
      hasCancel={false}
      triggerClose={triggerCloseLinkageModal}
    >
      <button className="bg-background-red py-1 w-[5.5rem] px-1 rounded-[4px] text-white">
        재고 연동하기
      </button>
    </Modal>
  ) : (
    <button
      disabled
      className="bg-[#dddddd] py-1 w-[5.5rem] px-1 rounded-[4px] text-[#555555]"
    >
      재고 연동완료
    </button>
  );
}

export function LotDataTable(props) {
  const { lotFilter, productData, prodId, setTriggerCloseDataModal } = props;
  const { isEmpty, getDataTableProps } = useLotData(lotFilter, prodId);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().totalAll;
  const [triggerCloseLinkageModal, setTriggerCloseLinkageModal] =
    useState(false);

  useEffect(() => {
    if (triggerCloseLinkageModal === true) {
      setTriggerCloseLinkageModal(false);
    }
  }, [triggerCloseLinkageModal]);

  const onCloseLinkageModal = () => {
    setTriggerCloseLinkageModal(true);
  };

  const columnExceptManual = columns(
    currentPage,
    pageSize,
    totalData,
    productData
  )?.filter((val) => val?.header !== "재고 연동관리");

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          {/* 등록된 상품이 없습니다.
          <br /> ONEDAY Mall에 상품을 등록하실 경우, '+ 상품등록'을
          진행해주세요. */}
        </div>
      ) : (
        <>
          <Table
            boldColumns={["최종 업데이트일"]}
            hasSort={false}
            hasPageSizeFilter={false}
            columns={
              lotFilter?.type === "MANUAL"
                ? columns(
                    currentPage,
                    pageSize,
                    totalData,
                    productData,
                    triggerCloseLinkageModal,
                    onCloseLinkageModal,
                    setTriggerCloseLinkageModal,
                    setTriggerCloseDataModal
                  )
                : columnExceptManual
            }
            hasSave={false}
            {...getDataTableProps()}
          />
        </>
      )}
    </>
  );
}
